<div class="my-account" (clickOutside)="toggleMenu(true)">
    <span (click)="toggleMenu()">
        <span class="drg-icon-user"></span><span class="main-link" [innerHTML]="translationPrefix + '.myAccount' | translate"></span>
    </span>

    <div class="secondarynavdropdown" [@openClose]="(isOpen$ | async) ? 'open' : 'closed'">
        <ul class="reset">
            <li *ngIf="!isPortal">
                <a
                    da-link
                    class="small"
                    [routerLink]="headerLinks.startPage | localize"
                    [innerHTML]="translationPrefix + '.myAccount' | translate"
                ></a>
            </li>
            <li>
                <a
                    da-link
                    class="small"
                    [routerLink]="headerLinks.myCourses | localize"
                    [innerHTML]="translationPrefix + '.myCourses' | translate"
                ></a>
            </li>
            <li>
                <a
                    da-link
                    class="small"
                    [routerLink]="headerLinks.personalData | localize"
                    [innerHTML]="translationPrefix + '.personalData' | translate"
                ></a>
            </li>
            <li>
                <da-logout></da-logout>
            </li>
        </ul>
    </div>
</div>
